import type { opsAdmin as opsAdminEn } from "../en/opsAdmin";

export const opsAdmin: typeof opsAdminEn = {
  common: {
    kind: "Druh",
    supplier: "Dodavatel",
    payment: "Platba",
    bookingMode: "Režim rezervace",
    global: "Globální",
    globalAnyDestination: "Globální (jakákoli destinace)",
    noSupplier: "Bez dodavatele",
    order: "Objednávka",
    editingName: "Úprava: {{name}}",
  },
  documents: {
    title: "Dokumenty",
    subtitle: "Vygenerované smlouvy, itineráře a balíčky — se stavem elektronického podpisu",
    allDocuments: "Všechny dokumenty",
    contracts: "Smlouvy",
    searchPlaceholder: "Hledat podle názvu…",
    audience: "Určeno pro",
    empty: "Žádné dokumenty",
    colDocument: "Dokument",
    colSigned: "Podepsáno",
    openPdf: "Otevřít PDF",
  },
  complaints: {
    title: "Reklamace",
    subtitle: "Reklamace zákazníků a kompenzace — sledované až do vyřešení",
    empty: "Žádné reklamace",
    colComplaint: "Reklamace",
    colCompensation: "Kompenzace",
  },
  suppliers: {
    title: "Dodavatelé",
    subtitle: "Hotely, aerolinky, pojišťovny a další dodavatelé, od kterých nakupujeme služby",
    new: "Nový dodavatel",
    pricedCatalog: "Katalog služeb",
    searchPlaceholder: "Hledat podle názvu, kontaktu, e-mailu…",
    empty: "Nenalezeni žádní dodavatelé",
    colSupplier: "Dodavatel",
    colContact: "Kontakt",
    paymentTermsDays_one: "{{count}} den",
    paymentTermsDays_few: "{{count}} dny",
    paymentTermsDays_other: "{{count}} dní",
    notFound: "Dodavatel nenalezen",
    editTitle: "Upravit dodavatele",
    newSubtitle: "Přidání dodavatele služeb",
    namePlaceholder: "např. Sofitel Legend Metropole Hanoi",
    contactName: "Kontaktní osoba",
    contactEmail: "Kontaktní e-mail",
    contactPhone: "Kontaktní telefon",
    emailTemplate: "E-mailová šablona",
    emailTemplateDefault: "Výchozí (automatická žádost o rezervaci podle druhu služby)",
    emailTemplateHint:
      "Nechte Výchozí, pokud dodavatel netrvá na pevném formátu — v tom případě vyberte šablonu (v Šablonách naklonujte „Supplier booking request“ a upravte ji).",
    notesPlaceholder: "Rezervační kontakt, smluvní podmínky, cokoli, co by měl tým vědět…",
    paymentProfile: "Platební profil",
    paymentProfileHint: "Určuje, které platební povinnosti hlídá provozní engine.",
    bookingModeHint:
      "„Na vyžádání“ = naše vlastní / vždy dostupná služba (naše loď): žádný e-mail se žádostí o rezervaci, žádný termín potvrzení, připraveno automaticky. Nové položky katalogu tento režim dědí.",
    paymentTerms: "Splatnost (dny)",
    commission: "Provize (%)",
  },
  components: {
    title: "Katalog služeb",
    subtitle:
      "Naceněné komponenty — nákladový základ, ze kterého garant vybírá při sestavování zájezdu",
    new: "Nová komponenta",
    searchPlaceholder: "Hledat podle názvu…",
    costScope: "Rozsah nákladů",
    empty: "Nenalezeny žádné komponenty",
    colComponent: "Komponenta",
    colCost: "Náklad",
    colSell: "Prodej",
    colMargin: "Marže",
    colScope: "Rozsah",
    notFound: "Komponenta nenalezena",
    editTitle: "Upravit komponentu",
    newSubtitle: "Přidání naceněné služby do katalogu",
    namePlaceholder: "např. Plavba zátokou Ha Long s přespáním — kajuta deluxe",
    notesPlaceholder: "Co je v ceně, rezervační podmínky…",
    cost: "Náklad",
    sellPrice: "Prodejní cena",
    marginLabel: "Marže:",
    costScopeHint: "Fixní na termín (pronajatý autobus), nebo se násobí počtem osob (pojištění).",
    bookingModeHint:
      "„Na vyžádání“ = vlastní / vždy dostupná služba (naše loď): žádná žádost dodavateli, žádný termín potvrzení, připraveno automaticky. Předvyplněno podle dodavatele; zde lze přepsat.",
  },
  templates: {
    title: "Šablony",
    subtitle: "Správa e-mailových a PDF šablon",
    new: "Nová šablona",
    searchPlaceholder: "Hledat šablony…",
    allTypes: "Všechny typy",
    allCategories: "Všechny kategorie",
    empty: "Žádné šablony",
    createFirst: "Vytvořit první šablonu",
    systemChip: "Systémová",
    updatedAt: "Upraveno: {{date}}",
    toastDuplicated: "Šablona zduplikována",
    toastDuplicateFailed: "Duplikování šablony se nezdařilo",
    toastDeleted: "Šablona smazána",
    toastDeleteFailed: "Smazání šablony se nezdařilo",
    systemCannotDelete: "Systémové šablony nelze smazat",
    deleteTitle: "Smazat šablonu",
    deleteMessage: "Opravdu chcete smazat šablonu „{{name}}“? Tuto akci nelze vrátit.",
    editTitle: "Upravit šablonu",
    versionCount: "Verze: {{version}}",
    versionHistory: "Historie verzí",
    aiGeneration: "AI generování",
    contentPlaceholder: "Začněte psát obsah šablony…",
    toastCreated: "Šablona vytvořena",
    toastSaved: "Šablona uložena",
    toastSaveFailed: "Uložení šablony se nezdařilo",
    errNameRequired: "Zadejte název šablony",
    errContentRequired: "Zadejte obsah šablony",
    namePlaceholder: "Název šablony",
    descriptionPlaceholder: "Volitelný popis",
    category: "Kategorie",
    subject: "Předmět",
    subjectPlaceholder: "Předmět e-mailu",
    categories: {
      newsletter: "Newsletter",
      booking: "Potvrzení rezervace",
      payment: "Platby",
      contract: "Smlouvy",
      invoice: "Faktury",
      voucher: "Poukazy",
      other: "Ostatní",
    },
    types: {
      email: "E-mail",
      pdf: "PDF dokument",
    },
    variables: "Proměnné",
    variableGroups: {
      customer: "Zákazník",
      trip: "Zájezd",
      order: "Objednávka",
      guide: "Průvodce",
      company: "Společnost",
      voucher: "Poukaz",
    },
    preview: "Náhled",
    previewEmpty: "Zde se zobrazí náhled…",
    previewIframeTitle: "Náhled šablony",
    versionRestored: "Verze obnovena",
    restoreFailed: "Obnovení verze se nezdařilo",
    noVersions: "Žádné verze",
    versionN: "Verze {{version}}",
    current: "Aktuální",
    noNote: "Bez poznámky",
    restore: "Obnovit",
    aiTitle: "AI generování obsahu",
    aiDescribe: "Popište šablonu",
    aiPromptPlaceholder:
      "Např.: Vytvoř e-mail s potvrzením rezervace zájezdu do Vietnamu s informacemi o platbě zálohy.",
    aiTone: "Tón komunikace",
    toneFormal: "Formální",
    toneFriendly: "Přátelský",
    toneExcited: "Nadšený",
    generate: "Vygenerovat",
    generatedSubject: "Vygenerovaný předmět",
    generatedContent: "Vygenerovaný obsah",
    use: "Použít",
    aiGenerateFailed: "Generování obsahu se nezdařilo",
  },
};
